export const CriterionRoute = (baseName, categoryType, measureType) => [
    {
        path: `/${baseName}/criterion_category/add`,
        name: `${baseName}.criterion_category.add`,
        component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
        props: {addAction: true, externType: categoryType}
    },
    {
        path: `/${baseName}/criterion_category/edit/:id`,
        name: `${baseName}.criterion_category.edit`,
        component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
        props: {updateAction: true, externType: categoryType}
    },
    {
        path: `/${baseName}/criterion/add`,
        name: `${baseName}.criterion.add`,
        component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
        props: {addAction: true, type: measureType}
    },
    {
        path: `/${baseName}/criterion/edit/:id`,
        name: `${baseName}.criterion.edit`,
        component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
        props: {updateAction: true, type: measureType}
    }
];